import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import SidebarComponent from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import UserList from '../../components/UserList';
import DashboardHome from '../../components/DashboardHome';
import OrcamentoList from '../../components/OrcamentoList';
import ClientList from '../../components/ClientList';
import Agenda from '../../components/Agenda';
import BusList from '../../components/BusList';
import ContasPagarList from '../../components/ContasList';
import RelatorioOnibus from '../../components/RelatorioOnibus';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Body = styled.div`
  display: flex;
  flex: 1;
  margin-left: ${props => (props.sidebarExpanded ? '220px' : '60px')};
  padding-top: 60px;
  transition: margin-left 0.3s ease;
`;

const Content = styled.div`
  flex: 1;
  background-color: white;
  padding: 10px;

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 15px;
  }
`;

const Dashboard = () => {
  const [selectedScreen, setSelectedScreen] = useState('dashboard');
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [focus, setFocus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const setFocusActive = (active) => {

    setFocus(active);
    setSidebarExpanded(!active);

  };

  const renderScreen = () => {
    switch (selectedScreen) {
      case 'dashboard':
        return <DashboardHome />;
      case 'users':
        return <UserList />;
      case 'viagens':
        return <OrcamentoList />;
      case 'onibus':
        return <BusList/>;
      case 'contas':
        return <ContasPagarList/>;
      case 'clients':
        return <ClientList />
      case 'agenda':
        return <Agenda $focus={focus} $setFocus={setFocusActive}/>
      default:
        return <div>Selecione uma opção no menu</div>;
    }
  };

  return (
    <Container>
      <Navbar />
      <Body sidebarExpanded={sidebarExpanded}>
        <SidebarComponent
          sidebarExpanded={sidebarExpanded}
          setSidebarExpanded={setSidebarExpanded}
          setSelectedScreen={setSelectedScreen}
        />
        <Content>{renderScreen()}</Content>
      </Body>
    </Container>
  );
};

export default Dashboard;
